import { render, staticRenderFns } from "./UsuarioAprovacaoDialog.vue?vue&type=template&id=26843a32"
import script from "./UsuarioAprovacaoDialog.vue?vue&type=script&lang=js"
export * from "./UsuarioAprovacaoDialog.vue?vue&type=script&lang=js"
import style0 from "./UsuarioAprovacaoDialog.vue?vue&type=style&index=0&id=26843a32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports